import { useCabinetClasses } from "@/lib/cabinets/dsl/registry";
import type { Id } from "@/lib/types";

interface Props {
  projectId: Id;
  onAdd: (classId: string) => void;
  disabled?: boolean;
}

/**
 * Left rail — click a card to drop a cabinet of that class at the room
 * origin. Drag-from-palette will land in Phase 1.1; click-to-add is
 * functional enough for the demo.
 *
 * Source: the live cabinet-class registry (embedded seed + any
 * documents in the `cabinet_classes` ddb collection authored by a
 * designer).
 */
export function CabinetPalette({ onAdd, disabled }: Props) {
  const { classes } = useCabinetClasses();
  return (
    <aside style={{ borderRight: "1px solid var(--line)", padding: 16, overflowY: "auto" }}>
      <div className="label">PALETTE</div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
        {classes.map((c) => (
          <button
            key={c.id}
            className="ghost"
            disabled={disabled}
            onClick={() => onAdd(c.id)}
            style={{
              textAlign: "left",
              padding: "10px 12px",
              display: "grid",
              gridTemplateColumns: "1fr auto",
              gap: 4,
              cursor: disabled ? "not-allowed" : "pointer",
            }}
          >
            <span style={{ fontWeight: 600 }}>{c.label}</span>
            <span className="muted" style={{ fontSize: 11 }}>{c.category}</span>
            <span className="muted" style={{ fontSize: 11, gridColumn: "1 / -1" }}>
              {c.defaults.w}″ × {c.defaults.h}″ × {c.defaults.d}″
            </span>
          </button>
        ))}
      </div>
      <div className="muted" style={{ marginTop: 16, fontSize: 11 }}>
        Click to add at room origin. Drag-and-drop coming in Phase 1.1.
      </div>
    </aside>
  );
}
